import { render } from "./FusionImage.vue?vue&type=template&id=8c995eee&scoped=true"
import script from "./FusionImage.vue?vue&type=script&lang=js"
export * from "./FusionImage.vue?vue&type=script&lang=js"

import "./FusionImage.vue?vue&type=style&index=0&id=8c995eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c995eee"]])

export default __exports__